// 26.1.11 Reflect.ownKeys(target)
var $export = require('./_export');

$export($export.S, 'Reflect', { ownKeys: require('./_own-keys') });



//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/~/.pnpm/core-js@2.6.12/~/core-js/modules/es6.reflect.own-keys.js
// module id = ../../../../../../core-js@2.6.12/node_modules/core-js/modules/es6.reflect.own-keys.js
// module chunks = 0